import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import { post } from "../../services/apiServices";
import { token } from "../../services/authServices";
import TextField from "material-ui/TextField";
import Checkbox from 'material-ui/Checkbox'
import Snackbar from 'material-ui/Snackbar'
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import { FormControlLabel } from "material-ui/Form";
import Dialog, { DialogTitle, DialogActions, DialogContent } from "material-ui/Dialog";
import Table, {
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { CircularProgress } from "material-ui/Progress";
import { head } from "lodash";

const styles = {
    closeIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        color: '#a9a9a9',
        cursor: 'pointer'
    },
    editIcon: {
        padding: '10px',
        cursor: 'pointer'
    },
    refreshIcon: {
        padding: '10px',
        cursor: 'pointer'
    },
    iconsWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        width: '120px',
        margin: '0 auto 40px'
    },
    headerButton: {
        marginLeft: '10px'
    },
    titleWrap: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        color: '#3f51b5'
    },
    table: {
        minWidth: 700,
    },
    tableRow: {
        cursor: 'pointer'
    },
    listItem: {
        width: "480px",
        alignItems: "flex-start",
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
    },
    listItemText: {
        flex: "1 1 50%"
    },
    listItemTtitle: {
        fontWeight: 600
    },
    progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    },
    select: {
        width: "100%"
    },
};
class BotParts extends Component {
    classes = this.props.classes;
    state = {
        openConfirm: false,
        openModal: false,
        openNewBotModal: false,
        currentItem: {
            groups: []
        },
        parts: [],
        categories: {},
        groups: {},
        supported_mime: [
            'application/svg+xml',
            'image/svg+xml',
        ],
        selectedParts: null,
        newBot: null,
        newBotStoring: false,
        newBotError: false

    }
    componentWillMount() {
        this.props.getParts()
    }

    componentWillReceiveProps(props) {
        if (props.parts && props.parts.items) {
            let categories = {}
            let groups = {}
            props.parts.categories.forEach(item => {
                categories[item.id] = item
            })
            props.parts.groups.forEach(item => {
                groups[item.id] = item
            })
            this.setState({
                parts: props.parts.items,
                categories,
                groups,
            })
        }
    }
    generateInitialBot = () => {
        let { parts } = this.props
        let newBot = {
            'name': {
                'value': '',
                'error': false
            },
            'status': 'enabled',
            'groups': [],
            'Head': [
                {
                    'price': {
                        'value': null,
                        'error': false
                    },
                    'order': {
                        'value': 1,
                        'error': false
                    },
                    'image': {
                        'value': '',
                        'error': false
                    },
                    'thumbnail': {
                        'value': '',
                        'error': false
                    }
                }
            ],
            'Body': {
                'price': {
                    'value': null,
                    'error': false
                },
                'image': {
                    'value': '',
                    'error': false
                },
            },
            'Legs': {
                'price': {
                    'value': null,
                    'error': false
                },
                'image': {
                    'value': '',
                    'error': false
                },
                'thumbnail': {
                    'value': '',
                    'error': false
                }
            },
            'Right Arm': {
                'price': {
                    'value': null,
                    'error': false
                },
                'image': {
                    'value': '',
                    'error': false
                },
                'thumbnail': {
                    'value': '',
                    'error': false
                }
            },
            'Left Arm': {
                'price': {
                    'value': null,
                    'error': false
                },
                'image': {
                    'value': '',
                    'error': false
                },
                'thumbnail': {
                    'value': '',
                    'error': false
                }
            },
        }

        if (parts && parts.categories) {
            parts.categories.forEach(cat => {
                if (cat.name == 'Whole Bot') {
                    newBot['Whole Bot'] = {
                        'image': {
                            'value': '',
                            'error': false
                        },
                    }
                }

                if (cat.name == 'Full body') {
                    newBot['Full body'] = {
                        'image': {
                            'value': '',
                            'error': false
                        },
                    }
                }

                if (newBot[cat.name]) {
                    if (cat.name == 'Head') {
                        newBot[cat.name][0].category_id = cat.id
                    } else {
                        newBot[cat.name].category_id = cat.id
                    }
                }
            })
        }

        this.setState({
            newBot: newBot,
            newBotStoring: false,
            newBotError: false
        })
    }
    addNewBotHead = () => {
        let newBot = { ...this.state.newBot }
        newBot["Head"].push(
            {
                'price': {
                    'value': null,
                    'error': false
                },
                'order': {
                    'value': newBot["Head"].length + 1,
                    'error': false
                },
                'image': {
                    'value': '',
                    'error': false
                },
                'thumbnail': {
                    'value': '',
                    'error': false
                },
                'category_id': newBot["Head"][0].category_id
            }
        )
        this.setState({ newBot })
    }

    removeNewBotHead = (index) => {
        let newBot = { ...this.state.newBot }
        newBot["Head"].splice(index, 1)
        this.setState({ newBot })
    }

    handleNewBotInputChange = (partName, inputName, value) => {
        let newBot = { ...this.state.newBot }
        if (newBot[partName]) {
            newBot[partName][inputName].value = value
            this.setState({ newBot })
        }
    }

    handleNewBotHeadInputChange = (index, inputName, value) => {
        let newBot = { ...this.state.newBot }
        if (newBot["Head"][index]) {
            newBot["Head"][index][inputName].value = value
            if (inputName == 'order') {
                newBot["Head"] = newBot["Head"].sort((a, b) => {
                    if (a.order.value > b.order.value) {
                        return 1
                    } else {
                        return -1
                    }
                }).map((item, index) => {
                    item.order.value = index + 1
                    return item
                })
            }
            this.setState({ newBot })
        }
    }

    handleNewBotImageChange = (partName, target, isThumbnail = false) => {
        let newBot = { ...this.state.newBot }
        if (newBot[partName]) {
            let file = target.files.length > 0 ? target.files[0] : {}
            if (file.type == this.state.supported_mime[0] || file.type == this.state.supported_mime[1]) {
                if (isThumbnail) {
                    newBot[partName].thumbnail.value = file
                } else {
                    newBot[partName].image.value = file
                }
                this.setState({ newBot })
            } else {
                target.value = null
                this.setState({
                    'openSnackbar': true,
                    'message': `This file type not supported`
                })
            }
        }
    }

    handleNewBotHeadImageChange = (index, target, isThumbnail = false) => {
        let newBot = { ...this.state.newBot }
        if (newBot["Head"][index]) {
            let file = target.files.length > 0 ? target.files[0] : {}
            if (file.type == this.state.supported_mime[0] || file.type == this.state.supported_mime[1]) {
                if (isThumbnail) {
                    newBot["Head"][index].thumbnail.value = file
                } else {
                    newBot["Head"][index].image.value = file
                }
                this.setState({ newBot })
            } else {
                target.value = null
                this.setState({
                    'openSnackbar': true,
                    'message': `This file type not supported`
                })
            }
        }
    }


    handleNewBotSelectGroupChange = e => {
        let { newBot, groups } = this.state
        newBot.groups = []

        e.target.value.forEach(groupId => {
            newBot.groups.push(groupId)
        })

        this.setState({
            newBot
        })
    }

    onSubmitNewBot = () => {
        let { parts } = this.props
        let partsToStore = []
        let wholeBotPrice = 0
        let wholeBotCatId = null
        let newBot = this.validateNewBot({ ...this.state.newBot })
        if (newBot.error) {
            this.setState({ newBot })
        } else {
            let botName = newBot.name.value
            let status = newBot.status

            if (parts && parts.categories) {

                parts.categories.forEach(cat => {
                    if (newBot[cat.name]) {
                        if (cat.name == 'Head') {
                            newBot[cat.name].forEach((part, index) => {
                                let newPart = {
                                    bot_name: botName,
                                    order: +part.order.value,
                                    price: +part.price.value,
                                    status: status,
                                    image: part.image.value,
                                    customshack_image: part.thumbnail.value,
                                    category_id: cat.id,
                                    groups: newBot.groups
                                }
                                partsToStore.push(newPart)
                                if (index === 0)
                                    wholeBotPrice += +part.price.value
                            });
                        } else {
                            if (cat.name == 'Whole Bot' || cat.name == 'Full body') {
                                wholeBotCatId = cat.id
                            }
                            let newPart = {
                                bot_name: botName,
                                order: '',
                                price: newBot[cat.name].price ? +newBot[cat.name].price.value : 0,
                                status: status,
                                image: newBot[cat.name].image.value,
                                customshack_image: newBot[cat.name].thumbnail ? newBot[cat.name].thumbnail.value : '',
                                category_id: cat.id,
                                groups: newBot.groups
                            }
                            partsToStore.push(newPart)
                            wholeBotPrice += newBot[cat.name].price ? +newBot[cat.name].price.value : 0
                        }

                    }
                })
            }

            let promices = []
            partsToStore.forEach(part => {
                if (part.category_id == wholeBotCatId) {
                    part.price = wholeBotPrice
                }
                promices.push(this.onSubmit(part, false))
            })
            this.setState({ newBotStoring: true })
            Promise.all(promices)
                .then(() => {
                    this.setState({ openNewBotModal: false, newBotError: false, newBotStoring: false })
                    this.props.getParts()
                })
                .catch(e => {
                    this.setState({ newBotError: true, newBotStoring: false })
                })
        }
    }

    validateNewBot = (newBot) => {
        let keys = Object.keys(newBot)
        newBot.error = false
        keys.forEach(key => {
            if (newBot[key] && typeof newBot[key] != 'string') {
                if (newBot[key].length > 0) {
                    newBot[key].forEach((part, index) => {
                        let partKeys = Object.keys(part)
                        if (partKeys.length > 0) {
                            partKeys.forEach(partKey => {
                                if (!newBot[key][index][partKey].value && newBot[key][index][partKey].value !== undefined) {
                                    newBot[key][index][partKey].error = true
                                    newBot.error = true
                                } else if (newBot[key][index][partKey].value && newBot[key][index][partKey].error) {
                                    newBot[key][index][partKey].error = false
                                }
                            })
                        }
                    })
                } else {
                    let partKeys = Object.keys(newBot[key])

                    if (newBot[key].value !== undefined) {
                        if (!newBot[key].value) {
                            newBot[key].error = true
                            newBot.error = true
                        } else if (newBot[key].value && newBot[key].error) {
                            newBot[key].error = false
                        }
                    } else if (partKeys.length > 0) {
                        partKeys.forEach(partKey => {
                            if (!newBot[key][partKey].value && newBot[key][partKey].value !== undefined) {
                                newBot[key][partKey].error = true
                                newBot.error = true
                            } else if (newBot[key][partKey].value && newBot[key][partKey].error) {
                                newBot[key][partKey].error = false
                            }
                        })
                    }
                }
            }
        });
        return newBot
    }

    handleOpenModalConfirm = (id, e) => {
        e.stopPropagation()

        this.setState({
            'openConfirm': true,
            'deleteId': id
        })
    }

    handleCloseModalConfirm = () => {
        this.setState({
            'openConfirm': false,
            'deleteId': null
        })
    }

    togglePartSelect = (part, selected) => {
        let selectedParts = this.state.selectedParts
        if (!selectedParts) {
            selectedParts = {}
        }
        if (selected) {
            selectedParts[part.id] = part
        } else {
            delete selectedParts[part.id]
        }
        if (Object.keys(selectedParts).length <= 0) {
            selectedParts = null
        }

        this.setState({ selectedParts })
    }

    rendersList = () => {
        let { parts, categories } = this.state
        let result = parts.map(item => {
            let isFullBody = item.category && (item.category.name == 'Full body' || item.category.name == 'Whole Bot')
            return (
                <TableRow
                    className={this.classes.tableRow}
                    key={item.id}>
                    <TableCell padding='none'>
                        <Checkbox
                            onChange={(e) => {
                                this.togglePartSelect(item, e.target.checked)
                            }}
                            color="primary"
                        />
                        {item.name}
                    </TableCell>
                    <TableCell padding='none'>

                        <img src={item.image_name} width="50px" />
                    </TableCell>
                    <TableCell padding='none'>
                        {item.price}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.category ? categories[item.category.id].name : ''}
                    </TableCell>
                    <TableCell width="135px" padding='none'>
                        <div className={this.classes.iconsWrapper}>
                            {isFullBody && <Icon
                                className={this.classes.refreshIcon}
                                onClick={(e) =>
                                    this.refreshFullPrice(item)}>
                                refresh
                            </Icon>}
                            <Icon
                                className={this.classes.editIcon}
                                onClick={(e) =>
                                    this.edit(item)}>
                                mode_edit
                            </Icon>
                            <Icon
                                className={this.classes.editIcon}
                                onClick={(e) =>
                                    this.handleOpenModalConfirm(item.id, e)}>
                                delete
                            </Icon>
                        </div>
                    </TableCell>
                </TableRow>
            )
        })

        return result.map(item => item)
    }

    edit = (item = {}) => {
        this.setState({ currentItem: item })
        this.handleOpenModal()
    }

    addBot = () => {
        this.handleOpenNewBotModal()
    }

    delete = id => {
        post(`/admin/bot-parts/${id}/delete`, {}, token).then(res => {
            this.handleCloseModalConfirm()
            this.props.getParts()
        }).catch(err => {
            this.setState({
                'openSnackbar': true,
                'message': `Part id "${id}" doesn't exist`
            })
        })
    }

    refreshFullPrice = (part) => {
        const parts = [...this.state.parts]
        const currentBotName = part.name.split(' ')[0].toLowerCase()
        let fullPrice = 0

        parts.forEach(item => {
            let nameParts = item.name.split(' ')
            let partName = nameParts[0].toLowerCase()
            if (item.category.name == 'Head' && !isNaN(nameParts[nameParts.length - 1]) && nameParts[nameParts.length - 1] != 1)
                return
            if (partName == currentBotName && item.category.name != 'Whole Bot' && item.category.name != 'Full body')
                fullPrice += item.price
        })

        if (part.price != fullPrice) {

            this.onSubmit({
                ...part,
                price: fullPrice
            }, false)

            this.setState({
                parts: parts.map(item => {
                    if (item.id == part.id)
                        item.price = fullPrice

                    return item
                })
            })
        }
    }

    handleOpenModal = () => {
        this.setState({ openModal: true })
    }

    handleCloseModal = () => {
        this.setState({ openModal: false })
    }

    handleOpenNewBotModal = () => {
        this.generateInitialBot()
        this.setState({ openNewBotModal: true })
    }

    handleCloseNewBotModal = () => {
        this.setState({ openNewBotModal: false })
    }

    handleInputChange = e => {
        let { currentItem } = this.state
        currentItem[e.target.name] = e.target.value;
        this.setState({ currentItem })
    }

    handleSelectCategoryChange = e => {
        let { currentItem, categories } = this.state
        let category = categories[e.target.value]
        currentItem.category_id = category.id
        currentItem.category = category
        this.setState({
            currentItem
        })
    }

    handleSelectGroupChange = e => {
        let { currentItem, groups } = this.state
        currentItem.groups = []

        e.target.value.forEach(groupId => {
            currentItem.groups.push(groups[groupId])

        })

        this.setState({
            currentItem
        })
    }

    handleImageChange = e => {
        let { currentItem } = this.state
        let file = e.target.files.length > 0 ? e.target.files[0] : {}
        if (file.type == this.state.supported_mime[0] || file.type == this.state.supported_mime[1]) {
            currentItem.image = file
            this.setState({
                currentItem
            })
        } else {
            e.target.value = null
            this.setState({
                'openSnackbar': true,
                'message': `This file type not supported`
            })
        }
    }

    handleCustomShackImageChange = e => {
        let { currentItem } = this.state
        let file = e.target.files.length > 0 ? e.target.files[0] : {}
        if (file.type == this.state.supported_mime[0] || file.type == this.state.supported_mime[1]) {
            currentItem.customshack_image = file
            this.setState({
                currentItem
            })
        } else {
            e.target.value = null
            this.setState({
                'openSnackbar': true,
                'message': `This file type not supported`
            })
        }
    }

    onSubmitPartsStatus = (status = 'enabled') => {
        const { selectedParts } = this.state
        if (selectedParts) {
            let parts = []
            Object.values(selectedParts).forEach((part, index) => {
                parts[index] = {
                    "id": part.id,
                    "status": status
                }
            })

            post('/admin/bot-parts/bulkupdate', {
                'parts': parts
            }, token).then(res => {
                this.handleCloseModal()
                this.props.getParts()
            })
        }

    }

    onSubmit = (newPart = null, single = true) => {
        const { currentItem, categories } = this.state
        if (!newPart) {
            newPart = { ...currentItem }
        }
        if (newPart) {

            let formData = new FormData()
            let nameParts = newPart.name ? newPart.name.split(' ') : []
            let category = newPart.category_id ? newPart.category_id : newPart.category.id
            let botName = newPart.bot_name ? newPart.bot_name : nameParts[0]

            let groups = []
            if (newPart.groups && newPart.groups.length > 0) {
                newPart.groups.forEach(group => {
                    if (typeof group == 'object')
                        groups.push(group.id)
                    else
                        groups.push(group)
                })
            }

            let order = ''
            if (categories[category].name === 'Head') {
                order = newPart.order ? newPart.order : !isNaN(nameParts[nameParts.length - 1]) ? nameParts[nameParts.length - 1] : 1;
            }

            formData.append('bot_name', botName || '')
            formData.append('order', order)
            formData.append('price', newPart.price || 0)
            formData.append('status', newPart.status || 'enabled')
            formData.append('image', newPart.image || '')
            formData.append('customshack_image', newPart.customshack_image || '')
            formData.append('category', category || '')
            formData.append('groups', JSON.stringify(groups || []))

            let id = newPart.id ? `/${newPart.id}` : ''

            if (single) {
                post(`/admin/bot-parts${id}`, formData, token, null, 'application/x-www-form-urlencoded').then(res => {
                    this.handleCloseModal()
                    this.props.getParts()
                })
            } else {
                return post(`/admin/bot-parts${id}`, formData, token, null, 'application/x-www-form-urlencoded')
            }
        }
    }

    render() {
        const { parts } = this.props
        const {
            openModal,
            openNewBotModal,
            currentItem,
            selectedParts,
            newBot,
            newBotError,
            newBotStoring
        } = this.state
        let isFetching = parts ? parts.isFetching : true;
        let partCategoriesReversed = []
        if (parts && parts.categories && parts.categories.length > 0) {
            partCategoriesReversed = parts.categories.sort((a, b) => {
                if (a.id < b.id) {
                    return 1
                } else {
                    return -1
                }
            })
        }
        let currentItemGroupIds = []
        if (currentItem && currentItem.groups) {
            currentItem.groups.forEach(group => {
                currentItemGroupIds.push(group.id)
            })
        }
        return isFetching ? (
            <div className={this.classes.progressWrapper}>
                <CircularProgress className={this.classes.progress} size={50} />
            </div>
        ) : (
            <div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.openSnackbar}
                    autoHideDuration={6000}
                    onClose={this.handleCloseSnackbar}
                    SnackbarContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{this.state.message}</span>}
                />
                <Dialog
                    open={this.state.openConfirm}
                    onClose={this.handleCloseModalConfirm}>
                    <DialogTitle>
                        <Icon
                            className={this.classes.closeIcon}
                            onClick={this.handleCloseModalConfirm}>
                            close
                        </Icon>
                        <br />
                        Are you sure you want delete this part?
                    </DialogTitle>
                    <DialogActions className={this.classes.justifyCenter}>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.delete(this.state.deleteId)}>
                            Yes
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={this.handleCloseModalConfirm}>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    className="modal-wrap align-center"
                    open={openModal}
                    onClose={this.handleCloseModal}
                    aria-labelledby="simple-dialog-title">
                    <Icon
                        className={this.classes.closeIcon}
                        onClick={this.handleCloseModal}>
                        close
                    </Icon>
                    {
                        currentItem.id ?
                            (
                                <DialogTitle id="simple-dialog-title">
                                    Edit part
                                </DialogTitle>
                            ) :
                            (
                                <DialogTitle id="simple-dialog-title">
                                    Add part
                                </DialogTitle>
                            )
                    }
                    {parts.categories && parts.categories.length > 0 && <div className="input-wrap">
                        <FormControl className={this.classes.select}>
                            <InputLabel htmlFor="category-select">
                                Category
                            </InputLabel>
                            <Select
                                value={currentItem.category ? currentItem.category.id : 0}
                                onChange={this.handleSelectCategoryChange}
                                inputProps={{
                                    id: "category-select",
                                }}
                                autoWidth
                            >
                                {parts.categories.map((item, index) => {
                                    return (<MenuItem key={index} value={item.id}>
                                        {item.name}
                                    </MenuItem>)
                                })}
                            </Select>
                        </FormControl>
                    </div>}
                    {parts.groups && parts.groups.length > 0 && <div className="input-wrap">
                        <FormControl className={this.classes.select}>
                            <InputLabel htmlFor="category-select">
                                Group
                            </InputLabel>
                            <Select
                                value={currentItemGroupIds}
                                onChange={this.handleSelectGroupChange}
                                inputProps={{
                                    id: "group-select",
                                }}
                                autoWidth
                                multiple
                            >
                                {parts.groups.map((item, index) => {
                                    return (<MenuItem key={index} value={item.id}>
                                        {item.name}
                                    </MenuItem>)
                                })}
                            </Select>
                        </FormControl>
                    </div>}
                    <div className="input-wrap">
                        <TextField
                            id="bot_name"
                            label="Bot Name"
                            name="bot_name"
                            value={currentItem.bot_name ? currentItem.bot_name : (currentItem.name ? currentItem.name.split(' ')[0] : '')}
                            onInput={this.handleInputChange}
                            margin="normal"
                            fullWidth
                        />
                    </div>
                    {currentItem.category && currentItem.category.name === 'Head' && <div className="input-wrap">
                        <TextField
                            id="order"
                            label="Head Order"
                            name="order"
                            value={currentItem.order ? currentItem.order : (currentItem.name && !isNaN(currentItem.name.split(' ').pop()) ? currentItem.name.split(' ').pop() : 1)}
                            onInput={this.handleInputChange}
                            margin="normal"
                            type="number"
                            fullWidth
                        />
                    </div>}
                    <div className="input-wrap">
                        <TextField
                            id="price"
                            label="Price"
                            name="price"
                            value={currentItem.price}
                            onInput={this.handleInputChange}
                            margin="normal"
                            type="number"
                            fullWidth
                        />
                    </div>
                    <div className="input-wrap">
                        <div>
                            <label>Select image</label>
                        </div>
                        <input
                            id="image"
                            name="image"
                            onChange={this.handleImageChange}
                            type="file"
                        />
                    </div>

                    {currentItem.category && currentItem.category.name !== 'Body' && currentItem.category.name !== 'Whole Bot' && currentItem.category.name !== 'Full body' && <div className="input-wrap">
                        <div>
                            <label>Select Thumbnail</label>
                        </div>
                        <input
                            id="customshack_image"
                            name="customshack_image"
                            onChange={this.handleCustomShackImageChange}
                            type="file"
                        />
                    </div>}
                    <div className="input-wrap">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={currentItem.status == 'disabled' ? false : true}
                                    onChange={(e) => {
                                        let status = e.target.checked ? 'enabled' : 'disabled'
                                        currentItem['status'] = status;
                                        this.setState({ currentItem })
                                    }}
                                    //onChange={this.handleInputChange}
                                    color="primary"
                                />
                            }
                            label="Available in Custom Shack"
                        />
                    </div>
                    <Button
                        variant="raised"
                        color="primary"
                        className={this.classes.button}
                        onClick={() => this.onSubmit()}
                    //disabled={disable}
                    >
                        {currentItem.id ? "Edit" : "Add"}
                    </Button>
                </Dialog>

                {newBot && <Dialog
                    className="modal-wrap"
                    open={openNewBotModal}
                    onClose={this.handleCloseNewBotModal}
                    aria-labelledby="simple-dialog-title"
                    maxWidth="md"
                    fullWidth={true}>
                    <Icon
                        className={this.classes.closeIcon}
                        onClick={this.handleCloseNewBotModal}>
                        close
                    </Icon>
                    <DialogTitle id="simple-dialog-title">
                        Add Bot
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            <TextField
                                id="bot_name"
                                label="Bot Name"
                                name="name"
                                value={newBot.name.value}
                                onChange={(e) => {
                                    let newBot = { ...this.state.newBot }
                                    newBot['name'].value = e.target.value;
                                    this.setState({ newBot })
                                }}
                                margin="normal"
                                error={newBot.name.error}
                            />
                        </div>

                        {parts.groups && parts.groups.length > 0 && <div >
                            <FormControl className={this.classes.select}>
                                <InputLabel htmlFor="category-select">
                                    Group
                                </InputLabel>
                                <Select
                                    value={newBot.groups}
                                    onChange={this.handleNewBotSelectGroupChange}
                                    inputProps={{
                                        id: "group-select",
                                    }}
                                    multiple
                                >
                                    {parts.groups.map((item, index) => {
                                        return (<MenuItem key={index} value={item.id}>
                                            {item.name}
                                        </MenuItem>)
                                    })}
                                </Select>
                            </FormControl>
                        </div>}

                        {partCategoriesReversed.map((cat) => {
                            let part = newBot[cat.name]

                            if (part) {
                                if (part.length > 0) {
                                    let heads = part
                                    return (
                                        <React.Fragment>
                                            <Grid
                                                container
                                                style={styles.grid}
                                                spacing={12}
                                            >
                                                <Grid /* style={styles.customGrid} */ item sm={12}>
                                                    <div >
                                                        <h3>{cat.name}</h3>
                                                    </div>
                                                </Grid>

                                            </Grid>
                                            {heads.map((head, index) => {
                                                return (
                                                    <Grid
                                                        container
                                                        style={styles.grid}
                                                        spacing={12}
                                                    >
                                                        <Grid /* style={styles.customGrid} */ item sm={3}>
                                                            {head.image !== undefined &&
                                                                <div className="center-vertically">
                                                                    <FileButton
                                                                        title="Select Image"
                                                                        value={head.image.value}
                                                                        error={head.image.error}
                                                                        name="image"
                                                                        onChange={e => this.handleNewBotHeadImageChange(index, e.target)}
                                                                    />
                                                                </div>
                                                            }
                                                        </Grid>
                                                        <Grid /* style={styles.customGrid} */ item sm={3}>
                                                            {head.thumbnail !== undefined &&
                                                                <div className="center-vertically">
                                                                    <FileButton
                                                                        title="Select Thumbnail"
                                                                        value={head.thumbnail.value}
                                                                        error={head.thumbnail.error}
                                                                        name="customshack_image"
                                                                        onChange={e => this.handleNewBotHeadImageChange(index, e.target, true)}
                                                                    />
                                                                </div>
                                                            }
                                                        </Grid>
                                                        <Grid /* style={styles.customGrid} */ item sm={3}>
                                                            {head.price !== undefined && <div className="center-vertically">
                                                                <TextField
                                                                    id="price"
                                                                    label="Price"
                                                                    name="price"
                                                                    value={head.price.value ? head.price.value : ''}
                                                                    onInput={e => this.handleNewBotHeadInputChange(index, e.target.name, e.target.value)}
                                                                    margin="normal"
                                                                    type="number"
                                                                    fullWidth
                                                                    error={head.price.error}
                                                                />
                                                            </div>}
                                                        </Grid>
                                                        <Grid /* style={styles.customGrid} */ item sm={2}>
                                                            {head.order !== undefined && heads.length > 1 && <div className="center-vertically">
                                                                <TextField
                                                                    id="order"
                                                                    label="Head Order"
                                                                    name="order"
                                                                    value={head.order.value}
                                                                    onInput={e => this.handleNewBotHeadInputChange(index, e.target.name, e.target.value)}
                                                                    margin="normal"
                                                                    type="number"
                                                                    fullWidth
                                                                    error={head.order.error}
                                                                />
                                                            </div>}
                                                        </Grid>
                                                        <Grid /* style={styles.customGrid} */ item sm={1}>
                                                            {heads.length > 1 && <div className="center-vertically">
                                                                <Icon
                                                                    //className={this.classes.editIcon}
                                                                    onClick={(e) =>
                                                                        this.removeNewBotHead(index)}>
                                                                    delete
                                                                </Icon>
                                                            </div>}
                                                        </Grid>

                                                    </Grid>
                                                )
                                            })}
                                            <Grid
                                                container
                                                style={styles.grid}
                                                spacing={12}
                                            >
                                                <Grid /* style={styles.customGrid} */ item sm={12}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={this.addNewBotHead}
                                                    //disabled={disable}
                                                    >
                                                        + Additional Head
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                } else {
                                    return (
                                        <Grid
                                            container
                                            style={styles.grid}
                                            spacing={12}
                                        >

                                            <Grid /* style={styles.customGrid} */ item sm={12}>
                                                <div >
                                                    <h3>{cat.name}</h3>
                                                </div>
                                            </Grid>

                                            <Grid /* style={styles.customGrid} */ item sm={3}>
                                                {part.image !== undefined &&
                                                    <div className="center-vertically">
                                                        <FileButton
                                                            title="Select Image"
                                                            value={part.image.value}
                                                            error={part.image.error}
                                                            name="image"
                                                            onChange={e => this.handleNewBotImageChange(cat.name, e.target)}
                                                        />
                                                    </div>
                                                }
                                            </Grid>
                                            <Grid /* style={styles.customGrid} */ item sm={3}>
                                                {part.thumbnail !== undefined &&
                                                    <div className="center-vertically">
                                                        <FileButton
                                                            title="Select Thumbnail"
                                                            value={part.thumbnail.value}
                                                            error={part.thumbnail.error}
                                                            name="customshack_image"
                                                            onChange={e => this.handleNewBotImageChange(cat.name, e.target, true)}
                                                        />
                                                    </div>
                                                }
                                            </Grid>
                                            <Grid /* style={styles.customGrid} */ item sm={3}>
                                                {part.price !== undefined && <div className="center-vertically">
                                                    <TextField
                                                        id="price"
                                                        label="Price"
                                                        name="price"
                                                        value={part.price.value ? part.price.value : ''}
                                                        onInput={e => this.handleNewBotInputChange(cat.name, e.target.name, e.target.value)}
                                                        margin="normal"
                                                        type="number"
                                                        fullWidth
                                                        error={part.price.error}
                                                    />
                                                </div>}
                                            </Grid>
                                        </Grid>
                                    )
                                }

                            } else {
                                return null
                            }

                        })}
                        <div >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={newBot.status == 'disabled' ? false : true}
                                        onChange={(e) => {
                                            let status = e.target.checked ? 'enabled' : 'disabled'
                                            let newBot = { ...this.state.newBot }
                                            newBot['status'] = status;
                                            this.setState({ newBot })
                                        }}
                                        //onChange={this.handleInputChange}
                                        color="primary"
                                    />
                                }
                                label="Available in Custom Shack"
                            />
                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Grid
                            container
                            style={styles.grid}
                            spacing={12}
                        >
                            <Grid /* style={styles.customGrid} */ item sm={12}>
                                {newBot.error && <div className="error-message">Please fill out all required fields.</div>}
                                {newBotError && <div className="error-message">Sorry, server error occurred while storing new bot.</div>}
                            </Grid>
                            <Grid /* style={styles.customGrid} */ container sm={12} justifyContent="center" alignItems="center">
                                <Button
                                    variant="raised"
                                    color="primary"
                                    className={this.classes.button}
                                    onClick={this.onSubmitNewBot}
                                //disabled={disable}
                                >
                                    {newBotStoring ? <CircularProgress size={25} color="secondary" /> : 'Create'}
                                </Button>
                            </Grid>

                        </Grid>
                    </DialogActions>
                </Dialog>}

                <div className={this.classes.titleWrap}>
                    <h2 className={this.props.classes.title}>Bot Parts</h2>
                    <div className={this.classes.titleWrap}>
                        <Button
                            variant="raised"
                            color="primary"
                            disabled={!selectedParts}
                            className={this.classes.headerButton}
                            onClick={() => this.onSubmitPartsStatus()}>
                            Show Parts
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            disabled={!selectedParts}
                            className={this.classes.headerButton}
                            onClick={() => this.onSubmitPartsStatus('disabled')}>
                            Hide Parts
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            className={this.classes.headerButton}
                            onClick={() => this.edit()}>
                            Add new part
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            className={this.classes.headerButton}
                            onClick={() => this.addBot()}>
                            Add new bot
                        </Button>
                    </div>

                </div>
                {parts && parts.items.length &&
                    <Table className={this.classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell padding='none'>
                                    NAME
                                </TableCell>
                                <TableCell padding='none'>
                                    IMAGE
                                </TableCell>
                                <TableCell padding='none'>
                                    PRICE
                                </TableCell>
                                <TableCell padding='none'>
                                    CATEGORY
                                </TableCell>
                                <TableCell padding='none'>
                                    ACTIONS
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.rendersList()}
                        </TableBody>
                    </Table>}
            </div>
        )
    }
}

class FileButton extends Component {
    setFileInputElement = (el) => {
        this.fileInputElement = el
    }
    onClick = () => {
        this.fileInputElement.click()
    }
    render() {
        return (
            <div className={`file-input-wrapper ${this.props.error ? 'error' : ''}`}>
                <input
                    ref={this.setFileInputElement}
                    className='file-input'
                    name={this.props.name}
                    onChange={this.props.onChange}
                    type="file"
                />
                <Button
                    variant="raised"
                    //color="primary"
                    onClick={this.onClick}
                    className='file-input-button'
                >
                    {this.props.title}
                </Button>
                <div className='file-input-label'>{this.props.value ? this.props.value.name : ''}</div>
            </div>
        )
    }
}

export default withStyles(styles)(BotParts);


// WEBPACK FOOTER //
// ./src/components/content/BotParts.js